import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const STEPS = [
  {
    number: '01',
    icon: 'ri-chat-smile-2-line',
    title: 'Atendimento Inicial',
    desc: 'Você entra em contato pelo WhatsApp ou formulário. Respondemos com agilidade e agendamos uma conversa para entender sua situação com atenção e sem julgamentos.',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'Análise do Caso',
    desc: 'Realizamos um estudo aprofundado da sua situação jurídica, identificando as melhores estratégias legais disponíveis e apresentando as opções de forma clara e objetiva.',
  },
  {
    number: '03',
    icon: 'ri-file-paper-2-line',
    title: 'Atuação Jurídica',
    desc: 'Com base na análise, desenvolvemos a estratégia mais adequada, elaboramos peças processuais de excelência e representamos seus interesses com expertise e dedicação.',
  },
  {
    number: '04',
    icon: 'ri-bar-chart-grouped-line',
    title: 'Acompanhamento Completo',
    desc: 'Mantemos você informado em cada fase do processo, prestando contas de todas as movimentações processuais e garantindo total transparência até a conclusão do seu caso.',
  },
];

export default function HowWeWork() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section id="como-atuamos" className="py-24 lg:py-32 bg-bege" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className={`max-w-2xl mb-16 reveal ${isVisible ? 'visible' : ''}`}>
          <span className="font-sans text-dourado-medio text-xs tracking-widest uppercase">
            Nossa Metodologia
          </span>
          <h2 className="font-serif text-marrom-escuro text-4xl lg:text-5xl font-light mt-3 mb-4 gold-line">
            Como <span className="font-semibold">Atuamos</span>
          </h2>
          <p className="font-sans text-marrom-medio text-base leading-relaxed">
            Cada caso é único. Nosso processo garante que você receba atenção
            personalizada e suporte jurídico completo do início ao resultado.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, idx) => (
            <div
              key={step.number}
              className={`reveal group ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${idx * 120}ms` }}
            >
              <div className="relative bg-white p-8 rounded-lg border border-marrom-claro/20 hover:border-dourado-principal/50 hover:shadow-none transition-all duration-400 h-full flex flex-col">
                {/* Number */}
                <span className="font-serif text-marrom-claro/25 text-7xl font-bold leading-none absolute top-4 right-5 select-none group-hover:text-dourado-principal/20 transition-colors duration-300">
                  {step.number}
                </span>

                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center bg-marrom-escuro rounded-lg mb-6 group-hover:bg-dourado-principal transition-colors duration-300">
                  <i className={`${step.icon} text-dourado-principal text-2xl group-hover:text-marrom-escuro transition-colors duration-300`} />
                </div>

                <h3 className="font-serif text-marrom-escuro text-xl font-semibold mb-3">
                  {step.title}
                </h3>
                <p className="font-sans text-marrom-medio text-sm leading-relaxed flex-grow">
                  {step.desc}
                </p>

                {/* Bottom accent */}
                <div className="w-8 h-0.5 bg-dourado-principal mt-6 group-hover:w-full transition-all duration-500" />
              </div>

              {/* Connector arrow (not on last) */}
              {idx < STEPS.length - 1 && (
                <div className="hidden lg:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 w-6 h-6 items-center justify-center text-dourado-principal/40">
                  <i className="ri-arrow-right-s-line text-2xl" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
